import React, {Component} from 'react';
import FilterCard from '../components/FilterCard'

import 'date-fns'
import format from 'date-fns/format'
import differenceInDays from 'date-fns/differenceInDays'
import { startOfDay, endOfDay, addDays } from 'date-fns/esm';
import { convertToTimeZone }  from 'date-fns-timezone';

// Error Popup
import ErrorPopup from '../components/ErrorPopup'

// Products
import {Card, Container, Row, Col} from 'react-bootstrap'
import Truncate from 'react-truncate'

import '../stylesheets/ProductsFilter.css'

class ProductsFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bikeProducts: undefined,
      allCities: undefined,
      StartDate: addDays(startOfDay(new Date()), 1),
      EndDate: addDays(endOfDay(new Date()), 2),
      formatStartDate: undefined,
      formatEndDate: undefined,
      city: "",
      country: "",
      open: false,
      error: undefined,
      loading: false
    }

    this.fetchCities = this.fetchCities.bind(this);
    this.fetchBikes = this.fetchBikes.bind(this);
  }

  componentDidMount() {
    console.log(this.props.match.params.country);
    this.setState({country: this.props.match.params.country})

    this.fetchCities()
  }

  fetchCities() {
    fetch('/api/getCities', {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        country: this.props.match.params.country,
      })
    })
    .then(response => response.json())
    .then(data => {
      this.setState({allCities: data.cities})
    })
  }

  fetchBikes() {
    fetch('/api/getBikes', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        city: this.state.city,
        country: this.state.country,
      })
    })
    .then(response => response.json())
    .then(data => {
      this.setState({bikeProducts: data.products})
      this.setState({loading: false})
    })
  }

  handleDateChange = (name, date) => {
    this.setState({ [name]: date });
  };

  /**
   * Selector Event for cities
   * The event name comes from FilterCard.js
   * city - Parameter for city selector
   * country - Parameter for country selector
   */
  handleSelectChange = (event) => {
    // City can be accessed using this.state.city
    // Country can be accessed using this.state.country

    this.setState({ [event.target.name]: event.target.value})
    this.setState({open: false})
  }

  handleSubmit = () => {
    this.setState({loading: true})
    let diff = differenceInDays(this.state.EndDate, this.state.StartDate);
    let startDate = format(this.state.StartDate, 'yyyy-MM-d 00:00:00')
    let endDate = format(this.state.EndDate, 'yyyy-MM-d 23:59:59')

    if (this.state.city === "" || this.state.city === undefined) {
      this.setState({ open: true})
      this.setState({error: "Must select a City"})
      this.setState({loading: false})
      console.log("Error: Must select a city");
    }
    else if (diff < 0) {
      this.setState({open: true})
      this.setState({error: "End Date must be equal to or after the start date"})
      this.setState({loading: false})
      console.log("Error: End Date must be equal to or after the start date")
    }
    else {
      console.log("No Error")
      this.fetchBikes();
      // this.setState({loading: false})
    }

  }

  handleClose = (event) => {
    this.setState({ open: false });
  };

  productClick = (item) => {
    console.log("Clicked", item);
    let url = "/product/"+item.id+"?start="+this.state.StartDate+"&end="+this.state.EndDate;
    this.props.history.push(url);
  }

  render() {
    // console.log(this.props.match); // Used for matching the url

    const RenderProducts = () => (
      <Container style={{marginTop: 40, marginBottom: 40}}>
        <Row>
          {
          this.state.bikeProducts.map(item => (
            <Col key={item.title} xs={6} sm={4}>
              <div style={{marginTop: 20}} onClick={() => this.productClick(item)}>
                <Card className="productCard">
                  <Card.Img variant="top" src={item.img_url} />
                  <Card.Body>
                    <Card.Title className="cardTitle">
                      <Truncate lines={2}>{item.title}</Truncate>
                    </Card.Title>
                    <Card.Text>
                      <Truncate lines={3}>{item.description}</Truncate>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer style={{alignItems: 'right'}} className="pull-right">
                    <Card.Text className="pull-right">${item.price}.00</Card.Text>
                  </Card.Footer>
                </Card>
              </div>
            </Col>
          ))
          }
        </Row>
      </Container>
    )

    return (
      <div>
        <ErrorPopup hideDuration={6000} errorOpen={this.state.open} handleErrorClose={this.handleClose.bind(this)} errorMessage={this.state.error} />
        <div className="filterContainer">
          <img className="img-fluid w-100" src={process.env.PUBLIC_URL + '/images/slider1.jpg'} alt="Title" style={{objectPosition: '50% 65%', objectFit: 'cover', height: 400}} />
          <div className="filterCard">
            <FilterCard handleSelectChange={this.handleSelectChange.bind(this)} handleDateChange={this.handleDateChange.bind(this)} handleSubmit={this.handleSubmit.bind(this)} StartDate={this.state.StartDate} EndDate={this.state.EndDate} city={this.state.city} country={this.props.match.params.country} countryDisabled={true} allCities={this.state.allCities} loading={this.state.loading}/>
          </div>
        </div>
        {
          this.state.bikeProducts ? <RenderProducts /> : null
        }
      </div>
    )
  }
}

export default ProductsFilter